/**
 * Доступ к почтовому клиенту
 * @param {Object} mailAccesses
 */
export function canMailClientAccess(mailAccesses) {
  return mailAccesses.client_access
}

/**
 * Доступ к настройкам аккаунтов
 * @param {Object} mailAccesses
 */
export function canMailAccountsAccess(mailAccesses) {
  return (
    mailAccesses.accounts_access ||
    mailAccesses.accounts_create ||
    mailAccesses.accounts_delete ||
    mailAccesses.accounts_update
  )
}

/**
 * Доступ для создания аккаунтов
 * @param {Object} mailAccesses
 */
export function canMailAccountsCreate(mailAccesses) {
  return mailAccesses.accounts_create
}

/**
 * Доступ для обновления аккаунтов
 * @param {Object} mailAccesses
 */
export function canMailAccountsUpdate(mailAccesses) {
  return mailAccesses.accounts_update
}

/**
 * Доступ для удаления аккаунтов
 * @param {Object} mailAccesses
 */
export function canMailAccountsDelete(mailAccesses) {
  return mailAccesses.accounts_delete
}

//Servers
/**
 * Просмотр серверов
 * @param {Object} mailAccesses
 */
export function canMailServersAccess(mailAccesses) {
  return (
    mailAccesses.servers_access ||
    mailAccesses.servers_create ||
    mailAccesses.servers_delete ||
    mailAccesses.servers_update
  )
}

/**
 * Создание серверов
 * @param {Object} mailAccesses
 */
export function canMailServersCreate(mailAccesses) {
  return mailAccesses.servers_create
}

/**
 * Обновление серверов
 * @param {Object} mailAccesses
 */
export function canMailServersUpdate(mailAccesses) {
  return mailAccesses.servers_update
}

/**
 * Удаление серверов
 * @param {Object} mailAccesses
 */
export function canMailServersDelete(mailAccesses) {
  return mailAccesses.servers_delete
}



// WEBPACK FOOTER //
// ./src/apps/mail/utils/access.js